import { Link } from "react-router-dom"
function Footer() {

    const footerYear = new Date().getFullYear()

  return (

<div className="fixed-bottom bg-white">    
<div className="container">
  <footer className="py-0 my-0">
    <ul className="nav justify-content-center border-bottom mb-0">
      <li className="nav-item"><Link to='/legals' id="textMentionLegal" href="#" className="nav-link pb-1 pt-1 text-muted">Mentions légales</Link></li>
    </ul>
    <p id="textCopyright" className="text-center text-muted">© {footerYear} Au détour de soi</p>
  </footer>
</div>
</div>
  )
}

export default Footer